var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-header',{attrs:{"fluid":"","breadcrumbs":false,"actions":[{
      label: _vm.$t('save'),
      primary: true,
      color: 'is-primary',
      action: _vm.submitForm
    }]}},[_c('h1',{staticClass:"title"},[_c('d-previous-btn',{attrs:{"path":'/properties/' + _vm.$route.params.property + '/application-files'}}),_vm._v("\n      "+_vm._s(_vm.$t('new_application_file'))+"\n    ")],1)]),_vm._v(" "),(_vm.property)?_c('v-form',{ref:"form",attrs:{"action":"create","property":_vm.property}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }